import Chart from 'chart.js/auto';

const ChartHook = {
  mounted() {
    const config = JSON.parse(this.el.dataset.config);

    const getOrCreateLegendList = (chart, id) => {
      const legendContainer = document.getElementById(id);
      let listContainer = legendContainer.querySelector('ul');

      if (!listContainer) {
        listContainer = document.createElement('ul');
        listContainer.className = 'flex flex-row flex-wrap p-0 m-0 mt-5';

        legendContainer.appendChild(listContainer);
      }

      return listContainer;
    };

    const htmlLegendPlugin = {
      id: 'htmlLegend',
      afterUpdate(chart, args, options) {
        const ul = getOrCreateLegendList(chart, options.containerID);

        // Remove old legend items
        while (ul.firstChild) {
          ul.firstChild.remove();
        }

        // Reuse the built-in legendItems generator
        const items = chart.options.plugins.legend.labels.generateLabels(chart);

        items.forEach((item) => {
          const li = document.createElement('li');
          li.className = 'flex flex-row items-center ml-3 cursor-pointer';

          const total = chart.getDatasetMeta(0).total;
          const currentValue = chart.data.datasets[0].data[item.index];
          const percentage = parseFloat(((currentValue / total) * 100).toFixed(2));

          li.onclick = () => {
            chart.toggleDataVisibility(item.index);
            chart.update();
          };

          // Color box
          const boxSpan = document.createElement('span');
          boxSpan.className = 'inline-block w-5 h-5 mr-2';
          boxSpan.style.background = item.fillStyle;
          boxSpan.style.borderColor = item.strokeStyle;
          boxSpan.style.borderWidth = item.lineWidth + 'px';

          // Text
          const textContainer = document.createElement('p');
          textContainer.className = 'm-0 text-sm text-gray-600';
          textContainer.style.textDecoration = item.hidden ? 'line-through' : '';

          const text = document.createTextNode(`${item.text} (${percentage}%)`);
          textContainer.appendChild(text);

          li.appendChild(boxSpan);
          li.appendChild(textContainer);
          ul.appendChild(li);
        });
      },
    };

    config.plugins = [htmlLegendPlugin];
    config.options.plugins.tooltip = {
      callbacks: {
        label: function (item) {
          const total = item.chart.getDatasetMeta(item.datasetIndex).total;
          var currentValue = item.dataset.data[item.dataIndex];
          var percentage = parseFloat(((currentValue / total) * 100).toFixed(2));

          currentValue = currentValue.toFixed(2);
          if (currentValue == Math.trunc(currentValue)) {
            currentValue = Math.trunc(currentValue);
          }

          return ` ${currentValue} (${percentage}%)`;
        },
        title: function (item) {
          return item[0].label;
        },
      },
    };

    new Chart(this.el.querySelector('canvas'), config);
  },
};

export default ChartHook;
